<template>
  <div class="index-view" :style="{ '--height': height, }">
    <div class="index-view-top">
      <van-icon name="arrow-left" @click="toBack" size="28" color="#ffffff" />
      <div class="title">{{ topName }}</div>
      <van-icon style="opacity: 0;" name="ellipsis" size="28" color="#ffffff" />
    </div>
    <div class="user-scroll">
      <div class="details">
        <div v-if="betInfo && daojishi == true"
          :class="betType == 'B4' ? 'wubeijing' : betType == 'B3' ? 'wubeijing' : 'jg'">

          <div class="lhh" style="width: calc(100vw - 40px)" v-if="betType == 'B3'">
            <img style="opacity: 0.5;" src="../assets/1113.png" alt="" />
            <img style="width: 139px;height: 139px;" v-if="betInfo.winningResult == 'B301'" src="../assets/1113.png"
              alt="" />
            <img style="width: 139px;height: 139px;" v-else-if="betInfo.winningResult == 'B302'"
              src="../assets/1112.png" alt="" />
            <img style="width: 139px;height: 139px;" v-else src="../assets/1111.png" alt="" />
            <img style="opacity: 0.5;" src="../assets/1112.png" alt="" />
            <div class="dingwei" style="display:flex">
              Hash:
              <p v-for="(item2, index2) in betInfo.blockhash" :key="index2"
                :class="item2.colorred == true ? 'colorred' : item2.colorblue == true ? 'colorblue' : ''">
                {{ item2.number }}</p>
            </div>
          </div>
          <div class="lhh" style="width: calc(100vw - 40px)" v-else-if="betType == 'B4'">
            <div style="opacity:0.5">
              <img style="width: 84px;height: 84px;" src="../assets/1114.png" alt="" />
              <div style="background: #00BFFF;">
                <p>{{ $t("entertainment.zhuang") }}</p>
              </div>
            </div>
            <img style="width: 139px;height: 139px;" v-if="betInfo.winningResult == 'B401'" src="../assets/1114.png"
              alt="" />
            <img style="width: 139px;height: 139px;" v-else-if="betInfo.winningResult == 'B402'"
              src="../assets/1115.png" alt="" />
            <img style="width: 139px;height: 139px;" v-else src="../assets/1111.png" alt="" />
            <div style="opacity:0.5">
              <img style="width: 84px;height: 84px;" src="../assets/1115.png" alt="" />
              <div>
                <p>{{ $t("entertainment.idle") }}</p>
              </div>
            </div>
            <div class="dingwei" style="display:flex">
              Hash:
              <p v-for="(item2, index2) in betInfo.blockhash" :key="index2"
                :class="item2.colorred == true ? 'colorred' : item2.colorblue == true ? 'colorblue' : ''">
                {{ item2.number }}</p>
            </div>
          </div>
          <div v-else>
            <div class="jeiguo" style="">
              <p>{{ matchInfo[betInfo.winningResult.split(',')[0]] || betInfo.winningResult.split(',')[0] }}</p>
            </div>
            <div :class="betInfo.flowOp == '1' ? 'win' : 'lose'" style="height:45px;line-height:96px">
              {{ betInfo.type == betInfo.winningResult.split(',')[0] ? 'WIN' : 'LOSE' }}
            </div>
            <div class="wenzi" style="display:flex;">
              <p>Hash:</p>
              <p v-for="(item2, index2) in betInfo.blockhash" :key="index2"
                :class="item2.colorred == true ? 'colorred' : item2.colorblue == true ? 'colorblue' : ''">
                {{ item2.number }}</p>
            </div>
            <div :class="betInfo.flowOp == '1' ? 'win' : 'lose'" style="height:45px;line-height:96px">
              <!-- {{ betInfo.flowOp == '1' ? 'WIN' : 'LOSE' }} -->
            </div>
            <div class="jeiguo">
              <p style="margin-left: auto;">{{ matchInfo[betInfo.winningResult.split(',')[0]] ||
                  betInfo.winningResult.split(',')[0]
              }}</p>
            </div>
          </div>
        </div>
        <div v-else :class="betType == 'B4' ? 'wubeijing' : betType == 'B3' ? 'wubeijing' : 'dt-v'">
          <div class="lhh" style="width: calc(100vw - 40px)" v-if="betType == 'B3'">
            <img src="../assets/1113.png" alt="" />
            <img style="width: 139px;height: 139px;" src="../assets/1111.png" alt="" />
            <img src="../assets/1112.png" alt="" />
          </div>
          <div class="lhh" style="width: calc(100vw - 40px)" v-else-if="betType == 'B4'">
            <div>
              <img style="width: 84px;height: 84px;" src="../assets/1114.png" alt="" />
              <div style="background: #00BFFF;">
                <p>{{ $t("entertainment.zhuang") }}</p>
              </div>
            </div>
            <img style="width: 139px;height: 139px;" src="../assets/1111.png" alt="" />
            <div>
              <img style="width: 84px;height: 84px;" src="../assets/1115.png" alt="" />
              <div>
                <p>{{ $t("entertainment.idle") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="hash">
        <div class="block">
          <div>{{ $t("details.block") }}hash</div>
          <div v-if="betInfo == ''">
            --
          </div>
          <div v-else @click="toBlock()" style="display:flex">
            <p v-for="(item2, index2) in betInfo.blockhash" :key="index2"
              :class="item2.colorred == true ? 'colorred' : item2.colorblue == true ? 'colorblue' : ''">
              {{ item2.number }}</p>
          </div>
        </div>
        <div class="block">
          <div>{{ $t("details.money") }}</div>
          <div>{{ betInfo ? betInfo.number : '--' }}</div>
        </div>
        <div class="block">
          <div>{{ $t("details.type") }}</div>
          <div>{{ betInfo ? matchInfo[betInfo.type] : '--' }}</div>
        </div>
        <div class="block">
          <div>{{ $t("details.resultValue") }}</div>
          <div>{{ betInfo ? betInfo.resultValue : '--' }}</div>
        </div>
      </div>
      <div class="all" @click="toHistory">
        <span>{{ $t("details.all") }}>></span>
      </div>
      <div class="bet-lists" v-if="betType == 'B1'">
        <div v-for="(item, index) in twoSidedAll" :key="index">
          <div :class="item.checked == true ? 'bet-checked' : ''" @click="changeStatus(item.bidType)">
            <p style="margin-bottom:0.25rem">{{ matchInfo[item.bidType] }}</p>
            <p>{{ $t("luckyhash.odds") }}:{{ item.odds }}</p>
          </div>
        </div>
      </div>
      <div class="bet-lists" v-if="betType == 'B2'">
        <div v-for="(item, index) in composeAll" :key="index">
          <div :class="item.checked == true ? 'bet-checked' : ''" @click="changeStatus(item.bidType)">
            <p style="margin-bottom:0.25rem">{{ matchInfo[item.bidType] }}</p>
            <p>{{ $t("luckyhash.odds") }}:{{ item.odds }}</p>
          </div>
        </div>
      </div>
      <div class="bet-lists" v-if="betType == 'B3'">
        <div v-for="(item, index) in dragonTigerAll" :key="index">
          <div :class="item.checked == true ? 'bet-checked' : ''" @click="changeStatus(item.bidType)">
            <p style="margin-bottom:0.25rem">{{ matchInfo[item.bidType] }}</p>
            <p>{{ $t("luckyhash.odds") }}:{{ item.odds }}</p>
          </div>
        </div>
      </div>
      <div class="bet-lists" v-if="betType == 'B4'">
        <div v-for="(item, index) in baccaratAll" :key="index">
          <div :class="item.checked == true ? 'bet-checked' : ''" @click="changeStatus(item.bidType)">
            <p style="margin-bottom:0.25rem">{{ matchInfo[item.bidType] }}</p>
            <p>{{ $t("luckyhash.odds") }}:{{ item.odds }}</p>
          </div>
        </div>
      </div>
      <div style="justify-content: space-between;" class="bet-lists" v-if="betType == 'B5'">
        <div style="margin-right:0;" v-for="(item, index) in gallbladderAll" :key="index">
          <div :class="item.checked == true ? 'bet-checked' : ''" @click="changeStatus(item.bidType)">
            <p style="margin-bottom:0.25rem">{{ item.bidName.slice(3, 4) }}</p>
            <p>{{ $t("luckyhash.odds") }}:{{ item.odds }}</p>
          </div>
        </div>
      </div>
      <div class="USDT">
        <div>USDT/TRX{{ $t("details.address") }}</div>
        <div></div>
      </div>
      <div class="number">
        <span>{{ putHash }}</span>
      </div>
      <div class="copy_address">
        <div @click="diaglog">
          <span>{{ $t("details.money") }}</span>
        </div>
        <div v-clipboard:copy="putHash" v-clipboard:success="onCopy" v-clipboard:error="onError">
          <span>{{ $t("details.copy") }}</span>
        </div>
      </div>
      <div class="Trc20">
        <div>
          <img src="../assets/img/ts.png" />
          {{ $t("details.ts") }}
        </div>
        <div>{{ $t("details.USDT") }}</div>
      </div>

      <div class="line"></div>
      <div class="game" v-html="articleLists.content" style="color:#999999;padding:0 1rem 1rem">
      </div>
    </div>
    <van-popup v-model:show="showmoney" position="center" :style="style">
      <div class="money">
        <div class="title">{{ $t("details.Betting_amount") }}</div>
        <div class="input">
          <input type="text" name="" id="" v-model="betNumber" :placeholder="tips" />
          <!-- <el-select
            v-model="value"
            placeholder="TRX"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
        </div>
        <div class="select-text" @click="iconShow = !iconShow">{{ value }}
          <van-icon :name="iconShow ? 'arrow-up' : 'arrow-down'" />
        </div>
        <div class="select-up" v-if="iconShow == true">
          <div @click="changeValue('USDT')">
            <p :class="value == 'USDT' ? 'active' : ''">USDT</p>
            <van-icon name="success" size="24" color="#FFC400" v-if="value == 'USDT'" />
          </div>
          <div @click="changeValue('TRX')">
            <p :class="value == 'TRX' ? 'active' : ''">TRX</p>
            <van-icon name="success" size="24" color="#FFC400" v-if="value == 'TRX'" />
          </div>
        </div>
        <div class="buttoncancel">
          <input type="button" name="" id="" :value="$t('details.cancel')" @click="showmoney = false" />
          <input type="button" name="" id="" :value="$t('details.confirm')" @click="toBet" />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { luckyRecordList, article, doHashCityInfo } from '@/utils/request'
export default {
  data() {
    return {
      iconShow: false,
      betInfoTimer: '', //下注记录计时器
      lucky: 1,
      show: true,
      showmoney: false,
      style: {
        background: '#161414',
        'border-radius': '15px 15px 15px 15px',
        opacity: 1
      },
      putHash: '',
      topName: '', //顶部标题
      betNumber: '', //投注金额
      betInfo: '', //投注页面信息
      articleLists: '',
      height: '', //屏幕高度
      twoSided: '', //双面
      compose: '', //组合
      dragonTiger: '', //龙虎合
      baccarat: '', //百家乐
      gallbladder: '', //独胆
      twoSidedAll: '', //双面
      composeAll: '', //组合
      dragonTigerAll: '', //龙虎合
      baccaratAll: '', //百家乐
      gallbladderAll: '', //独胆
      options: [
        {
          value: 'USDT',
          label: 'USDT'
        },
        {
          value: 'TRX',
          label: 'TRX'
        }
      ],
      value: 'TRX',
      matchInfo: {
        B101: this.$t('entertainment.big'),
        B102: this.$t('entertainment.small'),
        B103: this.$t('entertainment.single'),
        B104: this.$t('entertainment.double'),
        B201: this.$t('entertainment.forlarge'),
        B202: this.$t('entertainment.smallsingle'),
        B203: this.$t('entertainment.large_double'),
        B204: this.$t('entertainment.small_double'),
        B301: this.$t('entertainment.dragon'),
        B302: this.$t('entertainment.tiger'),
        B303: this.$t('entertainment.us'),
        B401: this.$t('entertainment.zhuang'),
        B402: this.$t('entertainment.idle'),
        B403: this.$t('entertainment.he'),
        B501: '1',
        B502: '2',
        B503: '3',
        B504: '4',
        B505: '5',
        B506: '6',
        B507: '7',
        B508: '8',
        B509: '9',
        B510: '0',
        A101: this.$t('entertainment.both_sides') + '-' + this.$t('entertainment.big'),
        A102: this.$t('entertainment.both_sides') + '-' + this.$t('entertainment.small'),
        A103: this.$t('entertainment.both_sides') + '-' + this.$t('entertainment.single'),
        A104: this.$t('entertainment.both_sides') + '-' + this.$t('entertainment.double'),
        A110: this.$t('entertainment.champion') + '-1',
        A111: this.$t('entertainment.champion') + '-2',
        A112: this.$t('entertainment.champion') + '-3',
        A113: this.$t('entertainment.champion') + '-4',
        A114: this.$t('entertainment.champion') + '-5',
        A115: this.$t('entertainment.champion') + '-6',
        A116: this.$t('entertainment.champion') + '-7',
        A117: this.$t('entertainment.champion') + '-8',
        A118: this.$t('entertainment.champion') + '-9',
        A119: this.$t('entertainment.champion') + '-10',
        A201: this.$t('entertainment.champion') + '-1',
        A202: this.$t('entertainment.champion') + '-2',
        A203: this.$t('entertainment.champion') + '-3',
        A204: this.$t('entertainment.champion') + '-4',
        A205: this.$t('entertainment.champion') + '-5',
        A206: this.$t('entertainment.champion') + '-6',
        A207: this.$t('entertainment.champion') + '-7',
        A208: this.$t('entertainment.champion') + '-8',
        A209: this.$t('entertainment.champion') + '-9',
        A210: this.$t('entertainment.champion') + '-10',
        A211: this.$t('entertainment.yajun') + '-1',
        A212: this.$t('entertainment.yajun') + '-2',
        A213: this.$t('entertainment.yajun') + '-3',
        A214: this.$t('entertainment.yajun') + '-4',
        A215: this.$t('entertainment.yajun') + '-5',
        A216: this.$t('entertainment.yajun') + '-6',
        A217: this.$t('entertainment.yajun') + '-7',
        A218: this.$t('entertainment.yajun') + '-8',
        A219: this.$t('entertainment.yajun') + '-9',
        A220: this.$t('entertainment.yajun') + '-10',
        A221: this.$t('entertainment.he') + '-3',
        A222: this.$t('entertainment.he') + '-4',
        A223: this.$t('entertainment.he') + '-5',
        A224: this.$t('entertainment.he') + '-6',
        A225: this.$t('entertainment.he') + '-7',
        A226: this.$t('entertainment.he') + '-8',
        A227: this.$t('entertainment.he') + '-9',
        A228: this.$t('entertainment.he') + '-10',
        A229: this.$t('entertainment.he') + '-11',
        A230: this.$t('entertainment.he') + '-12',
        A231: this.$t('entertainment.he') + '-13',
        A232: this.$t('entertainment.he') + '-14',
        A233: this.$t('entertainment.he') + '-15',
        A234: this.$t('entertainment.he') + '-16',
        A235: this.$t('entertainment.he') + '-17',
        A236: this.$t('entertainment.he') + '-18',
        A237: this.$t('entertainment.he') + '-19',
        A301: this.$t('entertainment.champion_one_size') + '-1',
        A302: this.$t('entertainment.champion_one_size') + '-2',
        A303: this.$t('entertainment.champion_one_size') + '-3',
        A304: this.$t('entertainment.champion_one_size') + '-4',
        A305: this.$t('entertainment.champion_one_size') + '-5',
        A306: this.$t('entertainment.champion_one_size') + '-6',
        A307: this.$t('entertainment.champion_one_size') + '-7',
        A308: this.$t('entertainment.champion_one_size') + '-8',
        A309: this.$t('entertainment.champion_one_size') + '-9',
        A310: this.$t('entertainment.champion_one_size') + '-10',
        A311: this.$t('entertainment.crown') + '-' + this.$t('entertainment.andbig'),
        A312: this.$t('entertainment.crown') + '-' + this.$t('entertainment.andsmall'),
        A313: this.$t('entertainment.crown') + '-' + this.$t('entertainment.andsingle'),
        A314: this.$t('entertainment.crown') + '-' + this.$t('entertainment.anddouble'),
        A315: this.$t('entertainment.championtwo') + '-' + this.$t('entertainment.big'),
        A316: this.$t('entertainment.championtwo') + '-' + this.$t('entertainment.small'),
        A317: this.$t('entertainment.championtwo') + '-' + this.$t('entertainment.single'),
        A318: this.$t('entertainment.championtwo') + '-' + this.$t('entertainment.double'),
        A401: this.$t('entertainment.big'),
        A402: this.$t('entertainment.small'),
        A403: this.$t('entertainment.single'),
        A404: this.$t('entertainment.double'),
        A501: this.$t('entertainment.daxiao') + '-' + this.$t('entertainment.forlarge'),
        A502: this.$t('entertainment.daxiao') + '-' + this.$t('entertainment.smallsingle'),
        A503: this.$t('entertainment.daxiao') + '-' + this.$t('entertainment.large_double'),
        A504: this.$t('entertainment.daxiao') + '-' + this.$t('entertainment.small_double'),
        A601: this.$t('entertainment.Long_Huge') + '-' + this.$t('entertainment.dragon'),
        A602: this.$t('entertainment.Long_Huge') + '-' + this.$t('entertainment.tiger'),
        A603: this.$t('entertainment.Long_Huge') + '-' + this.$t('entertainment.us'),
        A701: this.$t('entertainment.baccarat') + '-' + this.$t('entertainment.zhuang'),
        A702: this.$t('entertainment.baccarat') + '-' + this.$t('entertainment.idle'),
        A703: this.$t('entertainment.baccarat') + '-' + this.$t('entertainment.us'),
        A801: this.$t('entertainment.gallbladder')
      },
      tips: this.$t('details.inputmoney'), //请输入投注金额
      betType: '',
      daojishi: false
    }
  },
  created() {
    let h = document.documentElement.clientHeight || document.body.clientHeight;
    if (h > 0) {
      this.height = h + 'px' //页面高度
    } else {
      this.height = "100vh"
    }
  },
  mounted() {
    this.betType = this.$route.query.type
    this.topName = this.$route.query.name
    this.getCityInfo()
    this.tronwebLink()
  },
  beforeDestroy() {
    clearInterval(this.betInfoTimer)
  },
  methods: {
    changeValue(item) {
      this.value = item
      this.iconShow = false
    },
    toBlock() {
      let item
      if (this.matchBetInfo) {
        item = this.matchBetInfo.blockhash.slice(this.matchBetInfo.blockhash.length - 10, this.matchBetInfo.blockhash.length) || ''
        window.open('https://tronscan.io/#/block/' + item, '_blank')
      } else {
        item = ''
      }
    },
    changeStatus(type) {
      console.log(type)
      if (this.betType == 'B1') {
        this.twoSidedAll.map(item => {
          if (type == item.bidType) {
            item.checked = true
            this.putHash = item.address
          } else {
            item.checked = false
          }
        })
        console.log(this.twoSidedAll)
      } else if (this.betType == 'B2') {
        this.composeAll.map(item => {
          if (type == item.bidType) {
            item.checked = true
            this.putHash = item.address
          } else {
            item.checked = false
          }
        })
        console.log(this.twoSidedAll)
      } else if (this.betType == 'B3') {
        this.dragonTigerAll.map(item => {
          if (type == item.bidType) {
            item.checked = true
            this.putHash = item.address
          } else {
            item.checked = false
          }
        })
        console.log(this.twoSidedAll)
      } else if (this.betType == 'B4') {
        this.baccaratAll.map(item => {
          if (type == item.bidType) {
            item.checked = true
            this.putHash = item.address
          } else {
            item.checked = false
          }
        })
        console.log(this.twoSidedAll)
      } else if (this.betType == 'B5') {
        this.gallbladderAll.map(item => {
          if (type == item.bidType) {
            item.checked = true
            this.putHash = item.address
          } else {
            item.checked = false
          }
        })
        console.log(this.twoSidedAll)
      }
    },
    toBack() {
      this.$router.go('-1')
    },
    onCopy() {
      if (this.putHash) {
        this.$toast.success(this.$t('prompt.copy_success'))
      } else {
        this.$toast.success(this.$t('prompt.Bet_type'))
      }
    },
    onError() {
      this.$toast.fail(this.$t('prompt.copy_fail'))
    },
    //投注历史
    toHistory() {
      if (!localStorage.getItem('token')) {
        this.$router.push('/index')
        return
      }
      this.$router.push({
        path: '/history',
        query: {
          type: this.$route.query.type
        }
      })
    },
    diaglog() {
      if (this.$store.state.walletName) {
        if (this.putHash) {
          this.showmoney = true
        } else {
          this.$toast.success(this.$t('prompt.Bet_type'))
          return
        }
      } else {
        this.$toast.success(this.$t('phone.lj'))
      }
    },
    //投注
    toBet() {
      if (this.betNumber > 0 && Number(this.betNumber)) {
        let betNumber = this.betNumber * 1000000
        var obj = setInterval(async () => {
          if (window.tronWeb && window.tronWeb.defaultAddress.base58) {
            clearInterval(obj)
            if (this.value == 'USDT') {
              const trc20ContractAddress = 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t' //contract address
              let contract = await tronWeb.contract().at(trc20ContractAddress)
              let result = await contract.name().call()
              await contract.transfer(this.putHash, betNumber).send()
              this.$toast.success(this.$t('prompt.success'))
            } else {
              // console.log(tronWeb.isConnected())
              // //this.$toast.success(betNumber)
              // this.$toast.success('第-1步')
              // await tronLink.request({ method: 'tron_requestAccounts' })
              // this.$toast.success('第0步')
              // const tradeobj = await tronWeb.transactionBuilder.sendTrx(this.putHash, betNumber, this.$store.state.walletName);
              // this.$toast.success('第1步')
              // const signedtxn = await tronWeb.trx.sign(tradeobj);
              // this.$toast.success('第2步')
              // const receipt = await tronWeb.trx.sendRawTransaction(signedtxn);
              // const tradeobj = await tronWeb.transactionBuilder.sendTrx(this.putHash, betNumber, this.$store.state.walletName)
              // const signedtxn = await tronWeb.trx.sign(tradeobj)
              // const receipt = await tronWeb.trx.sendRawTransaction(signedtxn)
              // this.$toast.success(this.$t('prompt.success'))
              await tronLink.request({
                method: "tron_requestAccounts"
              });
              var tronweb = window.tronWeb
              var tx = await tronweb.transactionBuilder.sendTrx(
                this.putHash,
                betNumber,
                this.$store.state.walletName
              );
              var signedTx = await tronweb.trx.sign(tx);
              console.log(signedTx)
              var broastTx = await tronweb.trx.sendRawTransaction(signedTx);
              console.log(broastTx);

            }
          }
          this.showmoney = false
        }, 10)
      }
    },
    getCityInfo() {
      let temp
      if (this.$route.query.type == 'B1') {
        temp = 11
      } else if (this.$route.query.type == 'B2') {
        temp = 12
      } else if (this.$route.query.type == 'B3') {
        temp = 13
      } else if (this.$route.query.type == 'B4') {
        temp = 14
      } else if (this.$route.query.type == 'B5') {
        temp = 15
      }
      article({
        type: 'RULE_' + temp
      }).then(res => {
        if (res.code == '200') {
          this.articleLists = res.data
        }
      })
      this.betInfoTimer = setInterval(() => {
        luckyRecordList({
          current: '1',
          size: '1',
          type: this.$route.query.type,
          coin: this.value
        }).then(res => {
          if (res.code == '200' && res.data.records.length > 0) {
            let time = new Date().getTime()
            console.log(time - res.data.records[0].createTimestamp < 30000, time > res.data.records[0].createTimestamp)
            if (time - res.data.records[0].createTimestamp < 30000 && time > res.data.records[0].createTimestamp) {
              this.daojishi = true
            } else {
              this.daojishi = false
            }
            res.data.records.map((item, index) => {
              let blockhash = item.blockhash.slice(item.blockhash.length - 10, item.blockhash.length).split('')
              let temp = [
                { number: '', colorred: false, colorblue: false },
                { number: '', colorred: false, colorblue: false },
                { number: '', colorred: false, colorblue: false },
                { number: '', colorred: false, colorblue: false },
                { number: '', colorred: false, colorblue: false },
                { number: '', colorred: false, colorblue: false },
                { number: '', colorred: false, colorblue: false },
                { number: '', colorred: false, colorblue: false },
                { number: '', colorred: false, colorblue: false },
                { number: '', colorred: false, colorblue: false }
              ]
              for (let i = 0; i < blockhash.length; i++) {
                temp[i].number = blockhash[i]
                temp[i].colorred = false
                temp[i].colorblue = false
              }
              let red = 0
              let blue = 0
              for (let i = blockhash.length - 1; i > 0; i--) {
                if (blockhash[i] == item.resultValue.split(',')[0]) {
                  if (red == 0) {
                    temp[i].colorred = true
                    red = 1
                  }

                } else if (blockhash[i] == '0' && item.resultValue.split(',')[0] == '0') {
                  if (red == 0) {
                    temp[i].colorred = true
                    red = 1
                  }

                }
                if (blockhash[i] == item.resultValue.split(',')[1]) {
                  if (blue == 0 && red == 0) {
                    temp[i].colorblue = true
                    blue = 1
                  }
                } else if (blockhash[i] == '0' && item.resultValue.split(',')[1] == '0') {
                  if (blue == 0 && red == 0) {
                    temp[i].colorblue = true
                    blue = 1
                  }
                }
              }
              item.blockhash = temp
              this.betInfo = res.data.records[0]
            })
          }
        })
      }, 1000)
    },
    async tronwebLink() {
      this.loading = true
      const TronWeb = require('tronweb')
      const HttpProvider = TronWeb.providers.HttpProvider
      const fullNode = new HttpProvider('https://api.trongrid.io') //Your local TVM URL
      const solidityNode = new HttpProvider('https://api.trongrid.io')
      const eventServer = 'https://api.trongrid.io'
      const privateKey = '6d8d7cdc92dbcbe945643efe1a9fcd80d875ea82fbee3460ee0207611d12e1e9'
      const tronWeb = new TronWeb(fullNode, solidityNode, eventServer, privateKey)
      async function getList(index) {
        let contractAddress = 'TXr53fEnKw5KiuV5mDokVUmmeFfQUTeBpA' //合约地址
        let contract = await tronWeb.contract().at(contractAddress)
        let list = await contract.list(index).call()
        let arrLists = []
        if (list[0] != '410000000000000000000000000000000000000000' && list[0]) {
          arrLists[0] = {
            address: tronWeb.address.fromHex(list[0]),
            checked: false
          }
        }
        if (list[1] != '410000000000000000000000000000000000000000' && list[1]) {
          arrLists[1] = {
            address: tronWeb.address.fromHex(list[1]),
            checked: false
          }
        }
        if (list[2] != '410000000000000000000000000000000000000000' && list[2]) {
          arrLists[2] = {
            address: tronWeb.address.fromHex(list[2]),
            checked: false
          }
        }
        if (list[3] != '410000000000000000000000000000000000000000' && list[3]) {
          arrLists[3] = {
            address: tronWeb.address.fromHex(list[3]),
            checked: false
          }
        }
        return arrLists
      }
      async function getList1(index) {
        let contractAddress = 'TXr53fEnKw5KiuV5mDokVUmmeFfQUTeBpA' //合约地址
        let contract = await tronWeb.contract().at(contractAddress)
        let list = await contract.list1(index).call()
        let arrLists = []
        if (list[0] != '410000000000000000000000000000000000000000' && list[0]) {
          arrLists[0] = {
            address: tronWeb.address.fromHex(list[0]),
            checked: false
          }
        }
        if (list[1] != '410000000000000000000000000000000000000000' && list[1]) {
          arrLists[1] = {
            address: tronWeb.address.fromHex(list[1]),
            checked: false
          }
        }
        if (list[2] != '410000000000000000000000000000000000000000' && list[2]) {
          arrLists[2] = {
            address: tronWeb.address.fromHex(list[2]),
            checked: false
          }
        }
        if (list[3] != '410000000000000000000000000000000000000000' && list[3]) {
          arrLists[3] = {
            address: tronWeb.address.fromHex(list[3]),
            checked: false
          }
        }
        if (list[4] != '410000000000000000000000000000000000000000' && list[4]) {
          arrLists[4] = {
            address: tronWeb.address.fromHex(list[4]),
            checked: false
          }
        }
        if (list[5] != '410000000000000000000000000000000000000000' && list[5]) {
          arrLists[5] = {
            address: tronWeb.address.fromHex(list[5]),
            checked: false
          }
        }
        if (list[6] != '410000000000000000000000000000000000000000' && list[6]) {
          arrLists[6] = {
            address: tronWeb.address.fromHex(list[6]),
            checked: false
          }
        }
        if (list[7] != '410000000000000000000000000000000000000000' && list[7]) {
          arrLists[7] = {
            address: tronWeb.address.fromHex(list[7]),
            checked: false
          }
        }
        if (list[8] != '410000000000000000000000000000000000000000' && list[8]) {
          arrLists[8] = {
            address: tronWeb.address.fromHex(list[8]),
            checked: false
          }
        }
        if (list[9] != '410000000000000000000000000000000000000000' && list[9]) {
          arrLists[9] = {
            address: tronWeb.address.fromHex(list[9]),
            checked: false
          }
        }
        return arrLists
      }
      this.twoSided = await getList(1) //双面
      this.compose = await getList(2) //组合
      this.dragonTiger = await getList(3) //龙虎合
      this.baccarat = await getList(4) //百家乐
      this.gallbladder = await getList1(10) //独胆
      console.log(this.gallbladder)
      await this.getDoHashCityInfo('B1')
      await this.getDoHashCityInfo('B2')
      await this.getDoHashCityInfo('B3')
      await this.getDoHashCityInfo('B4')
      await this.getDoHashCityInfo('B5')
    },
    //下注赔率相关
    getDoHashCityInfo(item) {
      doHashCityInfo({
        type: item
      }).then(res => {
        if (res.code == '200') {
          if (item == 'B1') {
            this.twoSided.map((item, index) => {
              item = Object.assign(item, res.data.dtoList[index])
            })
            this.twoSidedAll = this.twoSided
            this.$store.commit('changeTwoSided', this.twoSidedAll)
          }
          if (item == 'B2') {
            this.compose.map((item, index) => {
              item = Object.assign(item, res.data.dtoList[index])
            })
            this.composeAll = this.compose
            this.$store.commit('changeCompose', this.composeAll)
          }
          if (item == 'B3') {
            this.dragonTiger.map((item, index) => {
              item = Object.assign(item, res.data.dtoList[index])
            })
            this.dragonTigerAll = this.dragonTiger
            this.$store.commit('changeDragonTiger', this.dragonTigerAll)
          }
          if (item == 'B4') {
            this.baccarat.map((item, index) => {
              item = Object.assign(item, res.data.dtoList[index])
            })
            this.baccaratAll = this.baccarat
            this.$store.commit('changeBaccarat', this.baccaratAll)
          }
          if (item == 'B5') {
            this.gallbladder.map((item, index) => {
              item = Object.assign(item, res.data.dtoList[index])
              item['checked'] = false
            })
            this.gallbladderAll = this.gallbladder
            this.$store.commit('changeGallbladder', this.gallbladderAll)
          }
        }
      })
    }
  }
}
</script>
<style>
.el-select-dropdown {
  z-index: 9999 !important;
}
</style>
<style lang="scss" scoped="scoped">
.index-view-top {
  height: 3.125rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.9375rem;

  .title {
    font-size: 1.125rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #ffffff;
  }
}

.wenzi {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;

  >p {
    font-size: 0.75rem;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
}

.colorred {
  color: #b51717 !important;
}

.colorblue {
  color: #1f49be !important;
}

/deep/.van-overlay {
  z-index: 999 !important;
}

.dt-v {
  padding-top: 15px;
  width: 160px;
  height: 210px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  animation-name: pulse;
  background-image: url('../assets/img1.png');
  background-position: center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  /* Safari and Chrome */
  -webkit-animation: mymove 1s;
  -webkit-animation-iteration-count: infinite;

  @keyframes mymove {
    0% {
      width: 130px;
      height: 190px;
    }

    25% {
      width: 135px;
      height: 195px;
    }

    50% {
      width: 140px;
      height: 200px;
    }

    75% {
      width: 135px;
      height: 195px;
    }

    100% {
      width: 130px;
      height: 190px;
    }
  }
}

.dingwei {
  color: #ffffff;
  position: absolute;
  display: flex;
  flex-direction: unset !important;
  width: 100%;
  bottom: 5px;
  z-index: 9999;

  >p {
    display: block;
    color: #ffffff;
  }
}

.lhh {
  display: flex;
  justify-content: center;
  padding: 30px 0;
  align-items: center;
  background: #110E31;
  position: relative;

  >div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    >div {
      width: 45px;
      height: 28px;
      background: #90ee90;
      border-radius: 2px 2px 2px 2px;
      margin-top: 10px;
      display: flex;
      justify-content: center;
      align-items: center;

      >p {
        font-size: 0.8125rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }
    }
  }

  img {
    width: 92px;
    height: 73px;
  }
}

.bet-lists {
  display: flex;
  padding: 1.5rem 1rem 0;
  flex-wrap: wrap;
  // justify-content: space-between;

  >div {
    margin-right: 1.8rem;

    &:nth-of-type(2n + 0) {
      margin-right: 3.125rem;
    }

    .bet-checked {
      background: linear-gradient(180deg, #ffdc68 0%, #f9c20b 100%) !important;

      >p {
        color: #000000 !important;
      }
    }

    >div {
      width: 79px;
      background: #110E31;
      border-radius: 5px 5px 5px 5px;
      padding: 1rem 0;
      margin: 0 0.625rem 0.625rem;

      >p {
        padding: 0 0.75rem;
        font-size: 0.6875rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        text-align: center;
      }
    }
  }
}

/deep/.el-select {
  height: 100%;
  display: flex;
  align-items: center;
  margin-right: 0.5rem;
  width: 6rem;

  .el-input__inner {
    background: none;
    font-size: 1rem;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #555555;
    // background: #161414;
    border: unset !important;
    padding: 0;
  }
}

.user-scroll {
  height: calc(var(--height) - 3.25rem);
  overflow-y: scroll;
}

.money {
  position: relative;
  width: 315px;
  // height: 183px;
  background: #161414;
  border-radius: 15px 15px 15px 15px;
  opacity: 1;
  text-align: center;
  padding: 11px 15px;

  .select-text {
    position: absolute;
    top: 3.75rem;
    right: 30px;
    font-size: 0.8125rem;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #999999;
  }

  .select-up {
    position: absolute;
    z-index: 1;
    top: 5.625rem;
    right: 1rem;
    width: 11rem;
    background: #222121;
    border-radius: 0.5rem;
    padding: 0.5rem 0;
    font-size: 0.8125rem;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #999999;

    .active {
      color: #ffc400 !important;
    }

    >div {
      padding: 0.3rem 1rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  .buttoncancel {
    display: flex;
    justify-content: space-between;
    padding: 0 0.625rem;

    input:nth-child(1) {
      width: 130px;
      height: 43px;
      border-radius: 22px 22px 22px 22px;
      opacity: 1;
      border: 1px solid #ffc400;

      font-size: 15px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffc400;
      background: none;
    }

    input:nth-child(2) {
      width: 130px;
      height: 43px;
      background: linear-gradient(180deg, #ffdb67 0%, #f8c007 100%);
      border-radius: 22px 22px 22px 22px;
      opacity: 1;

      font-size: 15px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #0c0b0b;
    }
  }

  .input {
    margin: 15px 0 29px 0;
    display: flex;
    align-items: center;
    border: 1px solid #484848;

    input {
      padding-left: 15px;
      width: 90%;
      height: 43px;
      border-radius: 4px 4px 4px 4px;
      opacity: 1;

      background: none;
      color: #ffffff;
    }
  }

  .title {
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
}

.line-one {
  height: 0px;
  opacity: 1;
  margin-top: 15px;
  border: 1px solid #272727;
  margin-bottom: 15px;
}

.game {
  padding: 0 15px;

  .details-Hash {
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;

    span {
      color: #ff693a;
    }
  }

  .one {
    margin-top: 15px;
    height: 19px;
    font-size: 13px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #f8c007;
  }

  .gamerules {
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
  }

  .TRX {
    height: 19px;
    font-size: 13px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}

.line {
  margin-bottom: 15px;
  margin-top: 15px;
  height: 6px;
  background: #060505;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
}

.Trc20 {
  margin-top: 25px;
  padding: 15px;
  // height: 73px;
  background: rgba($color: #ff693a, $alpha: 0.1);
  border-radius: 10px 10px 10px 10px;

  div:nth-child(1) {
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #ff693a;

    img {
      margin-right: 9px;
      width: 15px;
      height: 13px;
    }
  }

  div:nth-child(2) {
    margin-top: 5px;
    height: 19px;
    font-size: 13px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    margin-left: 28px;
  }
}

.copy_address {
  display: flex;
  justify-content: space-between;
  padding-left: 15px;

  div {
    text-align: center;
    line-height: 40px;
    margin-right: 15px;
    width: 100%;
    height: 43px;
    border-radius: 22px 22px 22px 22px;
    opacity: 1;
    border: 1px solid #f8c007;

    span {
      font-size: 15px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #f8c007;
    }
  }
}

.index-view {
  width: 100vw;
  height: var(--height);
  background: #020017;
}

.number {
  height: 3rem;
  margin: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  // height: 43px;
  background: #110E31;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  text-align: center;

  span {
    font-size: 13px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #999999;
  }
}

.USDT {
  margin: 20px 15px 15px;

  justify-content: space-between;

  div:nth-child(1) {
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
  }

  div:nth-child(2) {
    font-size: 12px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ff693a;
  }
}

.all {
  font-size: 11px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #555555;
  text-align: center;
}

.hash {
  // height: 72px;
  background: #110E31;
  border-radius: 10px 10px 10px 10px;
  opacity: 1;
  margin: 15px;
  padding: 15px;
  display: flex;
  justify-content: space-between;

  .block {
    width: 70px;
    text-align: center;

    div:nth-child(1) {
      font-size: 11px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      height: 2rem;
      overflow: hidden;
    }

    div:nth-child(2) {
      font-size: 13px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      padding-top: 0.5rem;
    }
  }
}

.jeiguo {
  height: 24px;
  display: flex;
  align-items: center;
  padding: 0 16px;

  >p {
    font-size: 0.875rem;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffc400;
  }
}

.lose {
  font-size: 1.125rem;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #c85555;
}

.win {
  font-size: 1.125rem;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: green;
}

.details {
  height: 210px;
  text-align: center;
  position: relative;

  .jg {
    padding-top: 15px;
    width: 160px;
    height: 210px;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    animation-name: pulse;
    background-image: url('../assets/jg.png');
    background-position: center center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    /* Safari and Chrome */
    -webkit-animation: mymove 1s;
    -webkit-animation-iteration-count: infinite;

    @keyframes mymove {
      0% {
        width: 130px;
        height: 190px;
      }

      25% {
        width: 135px;
        height: 195px;
      }

      50% {
        width: 140px;
        height: 200px;
      }

      75% {
        width: 135px;
        height: 195px;
      }

      100% {
        width: 130px;
        height: 190px;
      }
    }
  }
}

.wubeijing {
  width: calc(100vw - 40px);
  height: 210px;
  position: absolute;
  top: 0;
  left: 20px;
  animation-name: pulse;
  background-image: unset;
  /* Safari and Chrome */
  -webkit-animation: mymove2 1s;
  -webkit-animation-iteration-count: infinite;

  @keyframes mymove2 {
    0% {
      transform: scale(1, 1);
    }

    25% {
      transform: scale(0.975, 0.975);
    }

    50% {
      transform: scale(0.95, 0.95);
    }

    75% {
      transform: scale(0.975, 0.975);
    }

    100% {
      transform: scale(1, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/luckyhash/details.vue